
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import ToolLink from './ToolLink';

const ToolLinks = ({tools, par}) => {

    return (
        <Stack horizontal tokens={{childrenGap: 8}}>
            {(tools || []).map((item, index) => {
                return (
                    <ToolLink
                        key={index}
                        toolItem={item}
                        parItem={par}
                    />
                );
            })}
        </Stack>
    );
}

export default ToolLinks;
